import React from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// config

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const getInputProps = (size) => {
  if (size === "small") {
    return {
      height: "33px",
      fontSize: "12px",
      "&.MuiOutlinedInput-root": {
        fontSize: "12px",
      },
    };
  }
  return {
    height: "36px",
    fontSize: "14px",
    "&.MuiOutlinedInput-root": {
      fontSize: "14px",
    },
  };
};

const basicInputPropsDark = {
  "& fieldset": {
    borderColor: "#121212",
  },
  "&:hover fieldset": {
    borderColor: "#121212",
  },
  "&.Mui-error fieldset": {
    borderColor: "#121212",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#121212",
  },
};

const basicSelectProps = {
  minWidth: "90px",
  height: "36px",
  borderRadius: "4px",
  padding: "8px 12px",
};

const basicInputProps = {
  padding: "8px 8px 8px 16px",
  marginRight: "8px",
  fontSize: "14px",
};

const StyledSelect = styled(Select)(({ theme }) => ({
  ...basicSelectProps,
  "&.MuiOutlinedInput-root": {
    ...basicInputProps,
    "& .MuiSelect-select": {
      paddingLeft: "0px",
      paddingRight: "16px !important",
    },
    "& .MuiSvgIcon-root": {
      width: "20px",
    },
  },
}));

const StyledSelectDark = styled(Select)(({ theme, size, darkMode }) => ({
  ...basicSelectProps,
  color: "#fff",
  backgroundColor: "#121212",
  "&.MuiOutlinedInput-root": {
    ...basicInputProps,
    borderColor: "#505050",
    color: "#ffffff",
    backgroundColor: "#121212",
    border: "#505050 1px solid",
    ...basicInputPropsDark,
    "& .MuiSelect-select": {
      paddingLeft: "0px",
      paddingRight: "16px !important",
    },
    "& .MuiSvgIcon-root": {
      width: "20px",
      color: "#fff",
      backgroundColor: "#121212",
    },
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "10px",
  "&.MuiMenuItem-root": {},
}));

const StyledMenuItemDark = styled(MenuItem)(({ theme }) => ({
  fontSize: "10px",
  "&.MuiMenuItem-root": {
    "&.Mui-selected": {
      backgroundColor: "#505050",
    },
  },
}));

//
const Selection = ({
  size,
  darkMode,
  options,
  inputProps,
  MenuProps,
  fullWidth,
  ...rest
}) => {
  const classes = useStyles();
  // props
  const { sx, ...restProps } = rest;
  // local state

  const positionProps = {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
  };

  const CustomSelect = darkMode ? StyledSelectDark : StyledSelect;
  const CustomSelectItem = darkMode ? StyledMenuItemDark : StyledMenuItem;

  const getSelectSx = () => {
    if (fullWidth) {
      return {};
    }
    return sx;
  };

  return (
    <Box>
      <FormControl fullWidth={fullWidth}>
        <CustomSelect
          label=""
          inputProps={{
            ...inputProps,
            sx: {
              ...getInputProps(size),
            },
          }}
          MenuProps={{
            ...positionProps,
            ...MenuProps,
            sx: darkMode
              ? {
                  "& .MuiPaper-root": {
                    color: "#ffffff",
                    backgroundColor: "#121212",
                    border: "#505050 1px solid",
                  },
                }
              : {},
          }}
          sx={getSelectSx()}
          {...restProps}
        >
          {Array.isArray(options) &&
            options.map((opt, idx) => (
              <CustomSelectItem key={idx.toString()} value={opt.value}>
                {opt.label}
              </CustomSelectItem>
            ))}
        </CustomSelect>
      </FormControl>
    </Box>
  );
};

Selection.propTypes = {
  size: PropTypes.oneOf(["normal", "small"]),
  darkMode: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.any),
  inputProps: PropTypes.objectOf(PropTypes.any),
  MenuProps: PropTypes.objectOf(PropTypes.any),
  fullWidth: PropTypes.bool,
};

Selection.defaultProps = {
  size: "normal",
  darkMode: false,
  options: [],
  inputProps: {},
  MenuProps: {},
  fullWidth: false,
};

export default Selection;
